import React from "react";
import { useTranslation } from "react-i18next";
import Div from "@jumbo/shared/Div/Div";
import { Grid, Typography } from "@mui/material";

const ServicePartnerDashboard = () => {
  const { t } = useTranslation();

  return (
    <Div>
      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12}>
          <Typography variant="h2">
            {t("pages.home.dashboards.servicePartnerTitle", {
              defaultValue: "Dashboard (7)",
            })}
          </Typography>
        </Grid>
      </Grid>
    </Div>
  );
};

export default ServicePartnerDashboard;
